/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Pincode from "../../components/Pincode";

const AdminPincode = (props) => {
    return (
        <Pincode moduleType={'Admin'} {...props} />
    )
}

export default AdminPincode